import { Phone, FileText } from 'lucide-react';

export function HeroHome() {
  return (
    <section className="relative min-h-[500px] md:min-h-[600px] flex items-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="/images/hero-volet-charleroi.webp"
          alt="Réparation de volets roulants à Charleroi - Artisan intervenant sur un volet roulant de maison belge"
          title="Réparation volet roulant Charleroi"
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
        {/* Overlay anthracite → bleu-canard */}
        <div className="absolute inset-0 bg-gradient-to-br from-primary-500/85 via-primary-500/70 to-secondary-500/80"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 py-16 md:py-24">
        <div className="max-w-3xl">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight text-balance">
            Réparation & dépannage de volets roulants à Charleroi
          </h1>
          <p className="mt-4 md:mt-6 text-base md:text-lg text-white/85 max-w-2xl text-balance">
            Votre volet roulant est bloqué, cassé ou ne fonctionne plus ? Artisan spécialisé à Charleroi, 
            nous intervenons rapidement dans tout le Hainaut. Diagnostic gratuit, devis clair, garantie 10 ans.
          </p>

          {/* CTA buttons */}
          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <a
              href="tel:+3280020410"
              className="btn-primary text-base px-8 py-3.5 inline-flex items-center gap-2"
            >
              <Phone className="w-5 h-5" />
              Appeler le 0800 20 410
            </a>
            <Link
              to="/contact/"
              className="btn-secondary text-base px-8 py-3.5 inline-flex items-center gap-2"
            >
              <FileText className="w-5 h-5" />
              Demander un devis gratuit
            </Link>
          </div>

          {/* Reassurance badges */}
          <div className="mt-10 flex flex-wrap gap-3">
            {[
              'Intervention 7j/7',
              'Devis gratuit',
              'Garantie 10 ans',
              'Toutes marques',
            ].map((badge) => (
              <span
                key={badge}
                className="inline-flex items-center gap-1.5 px-4 py-2 bg-white/15 backdrop-blur-sm text-white text-sm font-medium rounded-full border border-white/20"
              >
                <span className="w-1.5 h-1.5 bg-accent-400 rounded-full" />
                {badge}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}